/* import __COLOCATED_TEMPLATE__ from './websites.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { EntityType } from 'embercom/models/data/entity-types';
import { type OverviewSectionArgs } from '../../overview';
import type AddWebsiteModalService from 'embercom/services/add-website-modal-service';
import { inject as service } from '@ember/service';

export default class Websites extends Component<OverviewSectionArgs> {
  entityType = EntityType.ExternalContent;
  @service declare appService: { app: $TSFixMe };
  @service declare addWebsiteModalService: AddWebsiteModalService;

  @action addSyncSource() {
    if (this.appService.app.canUseRevampPreSync) {
      this.addWebsiteModalService.openAddWebsiteSheet();
      return;
    }
    this.args.onAddSource('external_content');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::Overview::Sections::Websites': typeof Websites;
    'knowledge-hub/overview/sections/Websites': typeof Websites;
  }
}
